import { render, staticRenderFns } from "./NavigationDrawerStudNav.vue?vue&type=template&id=320e386e"
import script from "./NavigationDrawerStudNav.vue?vue&type=script&lang=js"
export * from "./NavigationDrawerStudNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports